import { ApiResponse } from '@/modules/auth/interfaces/apiResponse';
import AuthorizedApiClient from '@/modules/auth/models/authorizedApiClient';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { DataSource } from '@/modules/datatable/interfaces/DataSource';
import { DataSourceResponse } from '../models/DataSourceResponse';
import { DataSourceRequest } from '../models/DataSourceRequest';
export class BrokersListApi implements DataSource {
  public async fetch(request: DataSourceRequest): Promise<DataSourceResponse> {
    const response: AxiosResponse<ApiResponse<DataSourceResponse>> =
      await AuthorizedApiClient.post(`/broker/getList`, request);
    const data = response.data.data;

    return data;
  }

  public async list(request: DataSourceRequest, actingBrokerId?: number | null): Promise<DataSourceResponse> {
    let config: AxiosRequestConfig = {};

    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id': actingBrokerId,
        },
      };
    }

    const response: AxiosResponse<ApiResponse<DataSourceResponse>> =
      await AuthorizedApiClient.post(`/broker/list`, request);
    const data = response.data.data;

    return data;
  }
}
